export async function json(res: Response): Promise<any> {
    if (res.ok) {
        return res.json();
    }

    return res.text().then(text => Promise.reject(JSON.parse(text)))
}
